import { render } from "./PrivacyPolicy.vue?vue&type=template&id=101e0110&scoped=true"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=js"

import "./PrivacyPolicy.vue?vue&type=style&index=0&id=101e0110&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-101e0110"

export default script